/* eslint-disable */

/** unique or primary key constraints on table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeConstraint {
  /** unique or primary key constraint on columns "context_id", "attribute_id", "material_class_id" */
  MaterialClassAttributeAttributeIdMaterialClassIdKey = 'material_class_attribute_attribute_id_material_class_id_key',
  /** unique or primary key constraint on columns "material_class_attribute_id" */
  MaterialClassAttributePkey = 'material_class_attribute_pkey'
}

/** select columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_class_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeSelectColumnArgoMaterialClassAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_material_class_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeSelectColumnArgoMaterialClassAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.material_class_attribute" */
export enum ArgoMaterialClassAttributeUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

